import { useEffect, useState } from "react";
import Select from "react-select";

// styles
import "../../project/Project.css";

//gobal
import {
  accountDataStore,
  companyStore,
  userStore,
} from "../../../store/Store";

// components
import AccountVendorInvoiceListRows from "./AccountVendorInvoiceListRows";
import UpdatePopup from "../../../components/UpdatePopup";
import SearchBar from "../../../components/SearchBar";
import ErrorDisplay from "../../../components/ErrorDisplay";
import Loading from "../../../components/Loading";
import CommentsPopup from "../CommentsPopup";
// data
import {
  vendorInvoiceStatus,
  invoiceStatusFilterMap,
  companyTypeOptions,
} from "../../../data/collections-data";
// hooks
import useGetFetch from "../../../hooks/useGetFetch";
import AddAdjustment from "../AddAdjustment";
import BatchUpdatePopup from "../../../components/BatchUpdatePopup";
import InvoiceStatusFilter from "../../../invoiceComponents/InvoiceStatusFilter";

export default function AccountVendorInvoiceList({ isAsset }) {
  // gobal
  const accountVendorInvoices = accountDataStore(
    (data) => data.accountVendorInvoices,
  );

  const setAccountVendorInvoices = accountDataStore(
    (data) => data.setAccountVendorInvoices,
  );
  const setAccountVendorInvoiceTotals = accountDataStore(
    (data) => data.setAccountVendorInvoiceTotals,
  );
  const setInvoiceAdjustments = accountDataStore(
    (data) => data.setInvoiceAdjustments,
  );
  const setInvoiceCounts = companyStore((data) => data.setInvoiceCounts);
  const invoiceCounts = companyStore((data) => data.invoiceCounts);
  const currentCompany = userStore((data) => data.currentCompany);
  const currentUser = userStore((data) => data.currentUser);
  
  // local
  const [invoicesExist, setInvoicesExist] = useState({
    freight: false,
    asset: false,
  });
  const [body, setBody] = useState();
  const [trigger, setTrigger] = useState(false);
  const [triggerComments, setTriggerComments] = useState(false);
  const [triggerAdjustment, setTriggerAdjustment] = useState(false);
  // batch update values
  const [triggerBatchUpdate, setTriggerBatchUpdate] = useState(false);
  const [reqBody, setReqBody] = useState(null);
  const [title, setTitle] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [batchChecked, setBatchChecked] = useState(false);
  const [enableCheckBoxes, setEnableCheckBoxes] = useState(false);
  const [batchInvoices, setBatchInvoices] = useState([]);
  // other
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [displayInvoices, setDisplayInvoices] = useState([]);
  const [filter, setFilter] = useState("in_progress");
  const [vendorDD, setVendorDD] = useState([]);
  const [batchOptions, setBatchOptions] = useState([]);
  const [currentVendorType, setCurrentVendorType] = useState("All");
  const [selectValue, setSelectValue] = useState({
    value: "All/Vendors",
    label: "All Vendors",
  });
  const [companyType, setCompanyType] = useState({
    value: 0,
    label: "All Vendor Types",
  });

  const { isPending, error } = useGetFetch(
    `${process.env.REACT_APP_BACKEND}/lc/invoice-counts/0`,
    setInvoiceCounts,
  );

  const { isPending: adjustmentsPending, error: adjustmentsError } =
    useGetFetch(
      `${process.env.REACT_APP_BACKEND}/lc/invoice-adjustments/0?is_vendor=true&is_received=false`,
      setInvoiceAdjustments,
    );
    
  // get vendor dd
  useEffect(() => {
    const dd = [{ value: "All/Vendors", label: "All Vendors" }];
    if (accountVendorInvoices) {
      accountVendorInvoices.forEach((inv) => {
        if (inv.vendor_id !== 0) {
          const exists = dd.filter(
            (x) => x.value === `Vendor/${inv.vendor_id}`,
          );
          if (exists.length === 0) {
            dd.push({
              value: `Vendor/${inv.vendor_id}`,
              label: inv.vendor_name,
            });
          }
        } else if (inv.pc_carrier_id !== "") {
          const exists = dd.filter(
            (x) => x.value === `Carrier/${inv.pc_carrier_id}`,
          );
          if (exists.length === 0) {
            dd.push({
              value: `Carrier/${inv.pc_carrier_id}`,
              label: inv.vendor_name,
            });
          }
        } else if (inv.pc_driver_id !== "") {
          const exists = dd.filter(
            (x) => x.value === `Driver/${inv.pc_driver_id}`,
          );
          if (exists.length === 0) {
            dd.push({
              value: `Driver/${inv.pc_driver_id}`,
              label: inv.vendor_name,
            });
          }
        }
      });
    }
    setVendorDD(dd);
  }, [accountVendorInvoices]);

  // filter batch options depending on filter and company type
  useEffect(() => {
    setBatchOptions([]);
    var batchExistsLength;
    if (batchInvoices.length > 0) {
      batchExistsLength = batchInvoices.filter((x) => x.invoice).length;
    }
    if (enableCheckBoxes && batchExistsLength > 0) {
      var approvedInvsLength = batchInvoices.filter(
        (x) =>
          x.invoice &&
          (x.invoice.customer_approval_status_id === 23 ||
            x.invoice.customer_approval_status_id === 24),
      ).length;
      switch (filter) {
        case "in_progress":
          switch (currentVendorType) {
            case "Vendor":
            case "Carrier":
              setBatchOptions([{ value: 0, label: "Add Adjustment" }]);
              break;
            case "Driver":
              if (approvedInvsLength === batchExistsLength) {
                setBatchOptions([
                  { value: 0, label: "Add Adjustment" },
                  { value: 1, label: "Send Email" },
                  { value: 2, label: "Approve" },
                  { value: 3, label: "Dispute" },
                ]);
              } else {
                setBatchOptions([{ value: 0, label: "Add Adjustment" }]);
              }
              break;
            default:
              setBatchOptions([]);
              break;
          }
          break;
        case "approved":
          switch (currentVendorType) {
            case "Vendor":
            case "Carrier":
              setBatchOptions([{ value: 4, label: "Mark as Payed" }]);
              break;
            case "Driver":
              setBatchOptions([
                { value: 1, label: "Send Email" },
                { value: 4, label: "Mark as Payed" },
              ]);
              break;
            default:
              setBatchOptions([]);
              break;
          }
          break;
        case "paid":
          switch (currentVendorType) {
            case "Vendor":
            case "Carrier":
              setBatchOptions([]);
              break;
            case "Driver":
              setBatchOptions([{ value: 1, label: "Send Email" }]);
              break;
            default:
              setBatchOptions([]);
              break;
          }
          break;
        case "disputed":
          switch (currentVendorType) {
            case "Driver":
              setBatchOptions([{ value: 1, label: "Send Email" }]);
              break;
            default:
              setBatchOptions([]);
              break;
          }
          break;
        default:
          setBatchOptions([]);
          break;
      }
    }
  }, [currentVendorType, enableCheckBoxes, filter, batchInvoices]);

  // determine if freight and asset invoices exist
  useEffect(() => {
    if (accountVendorInvoices) {
      const freight = accountVendorInvoices.filter((x) => x.is_asset === false);
      const asset = accountVendorInvoices.filter((x) => x.is_asset === true);
      if (freight.length > 0) {
        setInvoicesExist((current) => ({
          ...current,
          freight: true,
        }));
      }
      if (asset.length > 0) {
        setInvoicesExist((current) => ({
          ...current,
          asset: true,
        }));
      }
    }
  }, [accountVendorInvoices]);

  // filter invoices
  useEffect(() => {
    var invoices;
    setCurrentVendorType("All");
    setSelectValue({ value: "All/Vendors", label: "All Vendors" });
    setCompanyType({
      value: 0,
      label: "All Vendor Types",
    });
    setBatchChecked(false);
    setBatchInvoices([]);
    if (accountVendorInvoices && !isAsset) {
      switch (filter) {
        case "in_progress":
          invoices = accountVendorInvoices.filter(
            (x) => x.invoice_status_id === 32 && !x.is_asset,
          );
          break;
        case "approved":
          invoices = accountVendorInvoices.filter(
            (x) => x.invoice_status_id === 29 && !x.is_asset,
          );
          break;
        case "paid":
          invoices = accountVendorInvoices.filter(
            (x) => x.invoice_status_id === 31 && !x.is_asset,
          );
          break;
        case "disputed":
          invoices = accountVendorInvoices.filter(
            (x) => x.invoice_status_id === 30 && !x.is_asset,
          );
          break;
        default:
          invoices = accountVendorInvoices.filter(
            (x) => x.invoice_status_id === 32 && !x.is_asset,
          );
      }
    } else if (accountVendorInvoices && isAsset) {
      switch (filter) {
        case "in_progress":
          invoices = accountVendorInvoices.filter(
            (x) => x.invoice_status_id === 32 && x.is_asset,
          );
          break;
        case "approved":
          invoices = accountVendorInvoices.filter(
            (x) => x.invoice_status_id === 29 && x.is_asset,
          );
          break;
        case "paid":
          invoices = accountVendorInvoices.filter(
            (x) => x.invoice_status_id === 31 && x.is_asset,
          );
          break;
        case "disputed":
          invoices = accountVendorInvoices.filter(
            (x) => x.invoice_status_id === 30 && x.is_asset,
          );
          break;
        default:
          invoices = accountVendorInvoices.filter(
            (x) => x.invoice_status_id === 32 && x.is_asset,
          );
      }
    }
    setFilteredInvoices(invoices);
    setDisplayInvoices(invoices);
  }, [filter, accountVendorInvoices, isAsset]);

  // handle vendor selection
  const handleSelect = (o) => {
    setCurrentVendorType("All");
    setSelectValue(o);
    setCompanyType({
      value: 0,
      label: "All Vendor Types",
    });
    setBatchChecked(false);
    setBatchInvoices([]);
    var invoices;
    const type = o.value.split("/", 2);
    switch (type[0]) {
      case "All":
        invoices = filteredInvoices;
        setEnableCheckBoxes(false);
        setCurrentVendorType("All");
        break;
      case "Vendor":
        if (accountVendorInvoices) {
          invoices = filteredInvoices.filter(
            (x) => x.vendor_id === parseInt(type[1]),
          );
          setEnableCheckBoxes(true);
          setCurrentVendorType("Vendor");
        }
        break;
      case "Carrier":
        if (accountVendorInvoices) {
          invoices = filteredInvoices.filter(
            (x) => x.pc_carrier_id === type[1],
          );
          setEnableCheckBoxes(true);
          setCurrentVendorType("Carrier");
        }
        break;
      case "Driver":
        if (accountVendorInvoices) {
          invoices = filteredInvoices.filter((x) => x.pc_driver_id === type[1]);
          setEnableCheckBoxes(true);
          setCurrentVendorType("Driver");
        }
        break;
      default:
        invoices = filteredInvoices;
        setEnableCheckBoxes(false);
        setCurrentVendorType("All");
        break;
    }
    setDisplayInvoices(invoices);
  };
  // handle company type selection
  const handleCompanyType = (o) => {
    setCurrentVendorType("All");
    setCompanyType(o);
    setSelectValue({ value: "All/Vendors", label: "All Vendors" });
    setBatchChecked(false);
    setBatchInvoices([]);
    var invoices;
    switch (o.value) {
      case 0:
        if (accountVendorInvoices) {
          invoices = filteredInvoices;
          setEnableCheckBoxes(false);
          setBatchChecked(false);
          setBatchInvoices([]);
        }
        break;
      case 2:
        if (accountVendorInvoices) {
          invoices = filteredInvoices.filter(
            (x) => x.company_type === "Carrier",
          );
          setEnableCheckBoxes(true);
          setCurrentVendorType("Carrier");
        }
        break;
      case 33:
        if (accountVendorInvoices) {
          invoices = filteredInvoices.filter(
            (x) => x.company_type === "Driver",
          );
          setCurrentVendorType("Driver");
          setEnableCheckBoxes(true);
        }
        break;
      case 34:
        if (accountVendorInvoices) {
          invoices = filteredInvoices.filter(
            (x) => x.company_type === "Account Company",
          );
          setCurrentVendorType("Vendor");
          setEnableCheckBoxes(true);
        }
        break;
      default:
        invoices = filteredInvoices;
        setEnableCheckBoxes(false);
        setCurrentVendorType("All");
        break;
    }
    setDisplayInvoices(invoices);
  };
  const handleBatchChecks = () => {
    setBatchChecked(!batchChecked);
    if (!batchChecked === true) {
      var arr = [];
      displayInvoices.forEach((inv) => {
        arr.push({
          invoice_info: {
            invoice_id: inv.id,
            receiving_company_name: inv.vendor_name,
            sending_company_name: currentCompany.company_name,
            invoice_name: inv.invoice_name,
            user_id: currentUser.id,
            receiving_company_id: inv.target_company_id,
            sending_company_id: inv.company_id,
          },
          invoice: inv,
          checked: true,
        });
      });
      setBatchInvoices(arr);
    } else {
      setBatchInvoices([]);
    }
  };

  const handleBatchAction = (o) => {
    const body = {
      invoices: [],
      invoices_info: [],
      action_type: "",
    };

    batchInvoices.forEach((inv) => {
      if (inv.checked) {
        body.invoices.push(inv.invoice);
        body.invoices_info.push(inv.invoice_info);
      }
    });
    body.action_type = o.label;
    if (body.invoices.length > 0) {
      setReqBody(body);
      setTitle(
        `Are you sure you want to ${o.label.toLowerCase()} for all of the selected invoices?`,
      );
      switch (o.label) {
        case "Send Email":
          setSuccessMessage("Emails Sent");
          break;
        case "Approve":
          setSuccessMessage("Invoices Approved");
          break;
        case "Dispute":
          setSuccessMessage("Invoices Disputed");
          break;
        case "Mark as Payed":
          setSuccessMessage("Invoices Payed");
          break;
        case "Add Adjustment":
          setSuccessMessage("Adjustments Added");
          break;
        default:
          setSuccessMessage("Invoices Updated");
          break;
      }
      if (o.label === "Add Adjustment") {
        setTriggerAdjustment(true);
      } else {
        setTriggerBatchUpdate(true);
      }
    }
  };

  if (error || adjustmentsError) {
    return <ErrorDisplay message={"Could not get invoice counts"} code={500} />;
  } else if (isPending || adjustmentsPending) {
    return <Loading />;
  }
  if (!accountVendorInvoices) {
    return <p className="no-docs-added">No Invoices Have Been Added</p>;
  } else {
    return !isAsset && invoicesExist.freight ? (
      <div>
        <div className="d-flex justify-content-between">
          <InvoiceStatusFilter
            setFilter={setFilter}
            invoiceCounts={invoiceCounts.vendor_freight_counts}
          />
          <SearchBar
            data={filteredInvoices}
            field={"invoice_name"}
            setData={setDisplayInvoices}
          />
          <Select
            key={"company_type"}
            name={"company_type"}
            options={companyTypeOptions}
            onChange={handleCompanyType}
            placeholder={"Company Type"}
            value={companyType}
            className="col-auto"
          />
          {batchOptions.length > 0 && batchInvoices.length > 0 && (
            <Select
              key={"batch_option"}
              name={"batch_option"}
              options={batchOptions}
              onChange={handleBatchAction}
              placeholder={"Batch Action"}
              className="col-auto"
            />
          )}
          <Select
            key={"vendor"}
            name={"vendor"}
            options={vendorDD}
            onChange={handleSelect}
            placeholder={"Vendors"}
            value={selectValue}
          />
        </div>
        {displayInvoices.length > 0 ? (
          <div className="load-display-list">
            <table className="table table-hover">
              <thead>
                <tr>
                  {enableCheckBoxes && (
                    <th>
                      <input
                        type="checkbox"
                        name="batch_check"
                        onChange={handleBatchChecks}
                        value={batchChecked}
                        checked={batchChecked}
                      />
                    </th>
                  )}
                  <th>Name</th>
                  <th>Customer Invoice</th>
                  <th>Vendor</th>
                  <th>Type</th>
                  <th>Start</th>
                  <th>End</th>
                  {(filter === "approved" || filter === "paid") && (
                    <th>Approved Date</th>
                  )}
                  <th>Loads</th>
                  <th>Weight (tons)</th>
                  <th>Cost</th>
                  <th>Adjustment</th>
                  <th>Total</th>
                  <th>Duplicate Tickets</th>
                  <th>Missing Tickets</th>
                  <th>Locked Loads</th>
                  <th>Action</th>
                  <th>Update Status</th>
                  <th>Comments</th>
                </tr>
              </thead>
              <tbody>
                <AccountVendorInvoiceListRows
                  isAsset={isAsset}
                  setBody={setBody}
                  setTrigger={setTrigger}
                  invoices={displayInvoices}
                  setTriggerComments={setTriggerComments}
                  setTriggerAdjustment={setTriggerAdjustment}
                  enableCheckBoxes={enableCheckBoxes}
                  batchInvoices={batchInvoices}
                  setBatchInvoices={setBatchInvoices}
                  batchChecked={batchChecked}
                  setBatchChecked={setBatchChecked}
                  filter={filter}
                />
              </tbody>
            </table>
          </div>
        ) : (
          <p className="no-docs-added">{`No ${invoiceStatusFilterMap[filter]} Invoices Exist`}</p>
        )}
        {trigger && (
          <UpdatePopup
            setTrigger={setTrigger}
            url={`${process.env.REACT_APP_BACKEND}/lc/account-vendor-invoice/${body.id}`}
            method={"PATCH"}
            title={
              body.invoice_status_id !== 30
                ? `Are you sure you want to update ${body.invoice_name} to ${
                    vendorInvoiceStatus[body.invoice_status_id]
                  }`
                : `Are you sure you want to refresh ${body.invoice_name}`
            }
            errorMessage={"Could not Update"}
            successMessage={"Status Changed"}
            setStates={[setAccountVendorInvoices, setAccountVendorInvoiceTotals, setInvoiceCounts]}
            setStateFields={["vendor_invoices", "vendor_invoice_totals", "invoice_counts"]}
            body={body}
          />
        )}
        {triggerComments && (
          <CommentsPopup inv={body} setTrigger={setTriggerComments} />
        )}
        {triggerAdjustment && (
          <AddAdjustment
            inv={batchInvoices.length > 0 ? batchInvoices[0] : body}
            setTrigger={setTriggerAdjustment}
            projectId={0}
            isVendor={true}
            id={0}
            batchInvoices={batchInvoices.length > 0 ? batchInvoices : null}
            setBatchChecked={setBatchChecked}
            setBatchInvoices={setBatchInvoices}
            setEnableCheckBoxes={setEnableCheckBoxes}
          />
        )}
        {triggerBatchUpdate && (
          <BatchUpdatePopup
            reqBody={reqBody}
            title={title}
            endpoint={`${process.env.REACT_APP_BACKEND}/pc/account-vendor-invoices-batch-update`}
            successMessage={successMessage}
            setStates={[
              setAccountVendorInvoices,
              setInvoiceCounts,
              setInvoiceAdjustments,
            ]}
            setStateKeys={["", "invoice_counts", "invoice_adjustments"]}
            setTrigger={setTriggerBatchUpdate}
            otherStates={[
              setBatchChecked,
              setBatchInvoices,
              setEnableCheckBoxes,
            ]}
            otherStateValues={[false, [], false]}
          />
        )}
      </div>
    ) : invoicesExist.asset && isAsset ? (
      <div>
        <div className="d-flex justify-content-between">
          <InvoiceStatusFilter
            setFilter={setFilter}
            invoiceCounts={invoiceCounts.vendor_asset_counts}
          />
          <SearchBar
            data={filteredInvoices}
            field={"invoice_name"}
            setData={setDisplayInvoices}
          />
          <Select
            key={"company_type"}
            name={"company_type"}
            options={companyTypeOptions}
            onChange={handleCompanyType}
            placeholder={"Company Type"}
            value={companyType}
            className="col-auto"
          />
          {batchOptions.length > 0 && batchInvoices.length > 0 && (
            <Select
              key={"batch_option"}
              name={"batch_option"}
              options={batchOptions}
              onChange={handleBatchAction}
              placeholder={"Select Batch Action"}
              className="col-auto"
            />
          )}
          <Select
            key={"vendor"}
            name={"vendor"}
            options={vendorDD}
            onChange={handleSelect}
            placeholder={"Vendors"}
            value={selectValue}
            className="search-select"
          />
        </div>
        {displayInvoices.length > 0 ? (
          <div className="load-display-list">
            <table className="table table-hover">
              <thead>
                <tr>
                  {enableCheckBoxes && (
                    <th>
                      <input
                        type="checkbox"
                        name="batch_check"
                        onChange={handleBatchChecks}
                        value={batchChecked}
                        checked={batchChecked}
                      />
                    </th>
                  )}
                  <th>Name</th>
                  <th>Customer Invoice</th>
                  <th>Vendor</th>
                  <th>Type</th>
                  <th>Start</th>
                  <th>End</th>
                  {(filter === "approved" || filter === "paid") && (
                    <th>Approved Date</th>
                  )}
                  <th>Loads</th>
                  <th>Weight (tons)</th>
                  <th>Cost</th>
                  <th>Adjustment</th>
                  <th>Total</th>
                  <th>Locked Loads</th>
                  <th>Action</th>
                  <th>Update Status</th>
                  <th>Comments</th>
                </tr>
              </thead>
              <tbody>
                <AccountVendorInvoiceListRows
                  isAsset={isAsset}
                  setBody={setBody}
                  setTrigger={setTrigger}
                  invoices={displayInvoices}
                  setTriggerComments={setTriggerComments}
                  setTriggerAdjustment={setTriggerAdjustment}
                  enableCheckBoxes={enableCheckBoxes}
                  batchInvoices={batchInvoices}
                  setBatchInvoices={setBatchInvoices}
                  batchChecked={batchChecked}
                  setBatchChecked={setBatchChecked}
                  filter={filter}
                />
              </tbody>
            </table>
          </div>
        ) : (
          <p className="no-docs-added">{`No ${invoiceStatusFilterMap[filter]} Invoices Exist`}</p>
        )}
        {trigger && (
          <UpdatePopup
            setTrigger={setTrigger}
            url={`${process.env.REACT_APP_BACKEND}/lc/account-vendor-invoice/${body.id}`}
            method={"PATCH"}
            title={
              body.invoice_status_id !== 30
                ? `Are you sure you want to update ${body.invoice_name} to ${
                    vendorInvoiceStatus[body.invoice_status_id]
                  }`
                : `Are you sure you want to refresh ${body.invoice_name}`
            }
            errorMessage={"Could not Update"}
            successMessage={"Status Changed"}
            setStates={[setAccountVendorInvoices, setAccountVendorInvoiceTotals, setInvoiceCounts]}
            setStateFields={["vendor_invoices", "vendor_invoice_totals", "invoice_counts"]}
            body={body}
            acInvoice={true}
          />
        )}
        {triggerComments && (
          <CommentsPopup inv={body} setTrigger={setTriggerComments} />
        )}
        {triggerAdjustment && (
          <AddAdjustment
            inv={batchInvoices.length > 0 ? batchInvoices[0] : body}
            setTrigger={setTriggerAdjustment}
            projectId={0}
            isVendor={true}
            id={0}
            isAsset={isAsset}
            batchInvoices={batchInvoices.length > 0 ? batchInvoices : null}
            setBatchChecked={setBatchChecked}
            setBatchInvoices={setBatchInvoices}
            setEnableCheckBoxes={setEnableCheckBoxes}
          />
        )}
        {triggerBatchUpdate && (
          <BatchUpdatePopup
            reqBody={reqBody}
            title={title}
            endpoint={`${process.env.REACT_APP_BACKEND}/pc/account-vendor-invoices-batch-update`}
            successMessage={successMessage}
            setStates={[
              setAccountVendorInvoices,
              setInvoiceCounts,
              setInvoiceAdjustments,
            ]}
            setStateKeys={["", "invoice_counts", "invoice_adjustments"]}
            setTrigger={setTriggerBatchUpdate}
            otherStates={[
              setBatchChecked,
              setBatchInvoices,
              setEnableCheckBoxes,
            ]}
            otherStateValues={[false, [], false]}
          />
        )}
      </div>
    ) : (
      <p className="no-docs-added">No Invoices Have Been Added</p>
    );
  }
}
